import * as fromDatatype from "../../../../models/datatype-library";

export class PgwFpxFormDtoModel {
    tenantCode?: string;
    paymentChannelCodePart?: string;
    txnHdrGuid?: string;
    billingAccount?: string;
    name?: string;
    email?: string;
    buyerId?: string;
    phoneNumber?: string;
    currency?: string;
    maxAmount?: string;
    maxFrequency?: string;
    frequencyMode?: string;
    pmtPurpose?: string;
    refNo?: string;
    bankId?: string;
    bankName?: string;
  }
  